var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3cpath fill='%23008751' d='M0 0h6v3H0z'/%3e%3cpath fill='white' d='M2 0h2v3H2z'/%3e%3c/svg%3e";
  export default img;